"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockProductFamilyImage = exports.mockProductFamilyOption = exports.mockProductFamily = void 0;
function mockProductFamily(overrides = {}) {
    return {
        available_colors: [],
        brand: 'mock brand',
        category: 'hardbaits',
        complimentary_product_families: [],
        created_at: '2022-10-20T21:01:51.682Z',
        description_data: '<strong>extra data!</strong>',
        handle: 'mock-handle',
        id: 1234567,
        images: [],
        img_url: 'http://example.com/jpg.jpg',
        meta_description: 'meta description',
        options: [mockProductFamilyOption()],
        popularity_30_day: 0,
        popularity: 0,
        price_max: 2.99,
        price_min: 1.99,
        products: [],
        related_product_families: [],
        rotate_images: [],
        subcategory: 'mocks-fakes',
        tags: [],
        title_short: 'mock title short',
        title: 'mock title',
        url_360: null,
        video_embed: null,
        ...overrides,
    };
}
exports.mockProductFamily = mockProductFamily;
function mockProductFamilyOption(overrides = {}) {
    return {
        name: 'WEIGHT',
        values: [{ value: '1/2 oz' }, { value: '1/4 oz' }],
        ...overrides,
    };
}
exports.mockProductFamilyOption = mockProductFamilyOption;
function mockProductFamilyImage(overrides = {}) {
    return {
        image: 'http://example/com/jpg.gif',
        alt_text: 'alt alt',
        display_order: null,
        ...overrides,
    };
}
exports.mockProductFamilyImage = mockProductFamilyImage;
